// utils/scrollManager.js
const scrollPositions = {};

export function saveScrollPosition(url) {
  scrollPositions[url] = { x: window.scrollX, y: window.scrollY };
}

export function restoreScrollPosition(url) {
  const pos = scrollPositions[url];
  if (pos) {
    window.scrollTo(pos.x, pos.y);
  } else {
    window.scrollTo(0, 0);
  }
}
